import { render, staticRenderFns } from "./expertgroup.vue?vue&type=template&id=1f432ec9&scoped=true"
import script from "./expertgroup.vue?vue&type=script&lang=js"
export * from "./expertgroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f432ec9",
  null
  
)

export default component.exports